import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: window.SENTRY_RELEASE,
  environment: import.meta.env.MODE,
})

window.Sentry = Sentry
